function ZakladyProgramovania(){
    return(<div>
        Zaklady Programovania
    </div>);
};

export default ZakladyProgramovania;